import {type FunctionalComponent, h} from '@stencil/core';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';


export interface GenericCardFilesDownload {
  documents: unknown;
  labelProvider: labelProviderInterface;
  toggleDialog: CallableFunction;
  documentDownloadAnalytics?: CallableFunction;
}

function getDownloadButtonText(props, files) {
    const label = props.labelProvider('result.document.download', 'Download');
    const extension = files.attachments[0]?.extension.toUpperCase();
    const sizeText = files?.attachments[0]?.length;
    return `${label} ${extension} ${sizeText}`;
}

export const GenericCardFilesDownload: FunctionalComponent<GenericCardFilesDownload> = (props) => {
    function generateDownloadPanel(files) {
        if (files.attachments.length == 1) {
          return <div
            class={`download-panel${files.attachments[0].extension.toUpperCase() !== 'PDF' ? '-only-download' : ''}`}>
            {files.attachments[0]?.extension.toUpperCase() === 'PDF' ?
              <qds-button
                href={files.attachments[0]?.url} target={'_blank'} onClick={() => {
                    props.documentDownloadAnalytics(
                      files.attachments[0]?.fileName,
                      files.f3Symbol || files.f2Symbol,
                      new URLSearchParams(files.attachments[0]?.url).get('p_Doc_Ref')
                    );
                }}
                icon-name="external-link" icon-library="core"
                text={props.labelProvider('result.document.view-online', 'View online')}>
              </qds-button>
              : null}

            <qds-button importance="subdued" href={files.attachments[0]?.url}
              download={files.attachments[0]?.fileName}
              onClick={(e) => {
                  props.documentDownloadAnalytics(
                    files.attachments[0]?.fileName,
                    files.f3Symbol || files.f2Symbol,
                    new URLSearchParams(files.attachments[0]?.url).get('p_Doc_Ref')
                  );
              }}
              icon-name={'arrow-down-tray'} icon-library={'default'}
              text={getDownloadButtonText(props, files)}
            >
            </qds-button>
          </div>
          ;
        } else if (files.attachments.length > 1) {
          return <div class={'download-panel-only-download'} >
            <qds-button
              importance="subdued"
              href={'javascript: void(0)'} onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  props.toggleDialog(true);
              }}
              text={props.labelProvider('result.document.files-for-download', 'Files for download')}
              icon-name={'window-cascade'} icon-library={'default'}
              data-skip-click-event={'true'} data-card-area={'files-for-download'}
            >
            </qds-button>
          </div>;
        }
    }

    return <section class='result-card__download-panel'>
      {generateDownloadPanel(props.documents)}
    </section>;
};
